import { render, staticRenderFns } from "./ProfileDs.vue?vue&type=template&id=7473b1d8&"
import script from "./ProfileDs.vue?vue&type=script&lang=js&"
export * from "./ProfileDs.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports